/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import {
    object, string, func, number, bool,
} from 'prop-types';
import { connect } from 'react-redux';

// Material ui
import { withStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import TypeChecking from '../../../../pages/Checkout/containers/CheckoutFloral/Partials/TextFieldWrapper/TypeChecking';

// redux
import { getSSRDeviceType } from '../../../../../state/ducks/App/App-Selectors';
import { getFeatureFlags, getPresentationFamily } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { loadAddToCartGiftMessage } from '../../../../../state/ducks/AddToCart/AddToCart-Actions';
import { getApplePayStatus, getTotalItemInCart } from '../../../../../state/ducks/Common/Common-Selectors';
import { googlePaySupportedBrand } from '../../../../../state/ducks/Payment/plugins/GooglePay/GooglePay-Helper';
import { getPassportSubscriptionStatus } from '../../../../../state/ducks/Passport/Passport-Selectors';

// component
import OccasionsDialog from './OccasionsDialog';

const styles = (theme) => ({
    optionalMessageMobile: {
        padding: '0 20px',
        background: '#f4f2f7',
        '& >div>div': {
            padding: '5px 0px 20px 0px',
        },
        '& .MuiInput-underline': {
            '&:before': {
                borderBottom: 'none',
            },
            '&:after': {
                borderBottom: 'none',
            },
        },
        '& .MuiPaper-elevation1': {
            boxShadow: 'none',
        },
        [theme.breakpoints.down('600')]: {
            marginTop: '10px',
        },
    },
    root: {
        width: '100%',
        color: '#000',
    },
    checkbox: {
        color: '#693388',
        padding: '16px 11px',
        '&$checked': {
            color: '#693388',
        },
        [theme.breakpoints.down('600')]: {
            '& svg': {
                fontSize: '24px',
            },
        },
    },
    formCheckBoxLabel: {
        [theme.breakpoints.down('600')]: {
            fontSize: '15px',
        },
    },
    checked: {
        color: '#693388',
        '&$checked': {
            color: '#693388',
        },
    },
    messageHeader: {
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'space-between',
        margin: '10px 0',
        [theme.breakpoints.down('xs')]: {
            margin: 0,
            alignItems: 'center',
        },
    },
    paperBody: {
        boxSizing: 'border-box',
        padding: '10px 10px 12px 10px',
    },
    textField: {
        width: '100%',
        height: '106px',
        border: 'none',
        '& label': {
            color: '#A5A5A5',
        },
        '& label[class*="focused"]': {
            color: '#5F3C86',
        },
    },
    displayNone: {
        display: 'none',
    },
    displayBlock: {
        display: 'block',
    },

    // Suggested Messages
    suggestedMessagesLink: {
        fontSize: '12px',
        color: theme.palette.colorNeutral70,
        textDecoration: 'underline',
        cursor: 'pointer',
    },

    // Suggested Messages Dialog
    dialogPaperWidth: {
        maxWidth: '800px',
    },
    dialogWrapper: {
        display: 'flex',
        position: 'absolute',
        top: '0',
        height: '400px',
        transition: 'all 0.2s ease-in-out 0s',
    },
    dialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        borderBottom: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        '& h3': {
            margin: '2px 0',
        },
    },
    backButton: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        outline: 0,
    },
    openCheckBox: {
        color: theme.palette?.cms?.primary || '#693388',
        padding: '10px 5px 10px 0px',
    },
});

class GraphqlPDPGiftMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            textField: '',
            characterCount: 0,
            maxCharacters: 200,
            showGiftMessage: false,
            showSuggestedMessages: false,
            occasionIndex: {},
            activePanel: 0,
            occasionCode: null,
        };
    }

    componentDidMount() {
        const { callHandleChangeGiftMessage } = this.props;
        callHandleChangeGiftMessage('', '');
    }

    handleChange = (event) => {
        const { callHandleChangeGiftMessage } = this.props;
        const { maxCharacters, occasionCode } = this.state;
        let resultValue = event.target.value;
        if (resultValue.length <= maxCharacters) {
            // Review the restriction in the input
            const dataToCheck = { value: event.target.value };
            const restrictInput = TypeChecking.MultilineGiftMessage;
            if (restrictInput) {
                resultValue = (restrictInput) ? restrictInput(dataToCheck) : dataToCheck.value;
            }

            const pippedMessage = resultValue.replace(/\n/g, '|');

            callHandleChangeGiftMessage(pippedMessage, occasionCode);

            this.setState({
                textField: resultValue,
                characterCount: resultValue.length,
            });
        }
    };

    handleShowGiftMessage = () => {
        const { showGiftMessage } = this.state;
        this.setState({
            showGiftMessage: !showGiftMessage,
        });
    };

    handleToggleSuggestedMessages = () => {
        const { showSuggestedMessages, activePanel } = this.state;
        this.setState({
            showSuggestedMessages: !showSuggestedMessages,
            activePanel: activePanel === 1 ? 0 : 0,
        });
    };

    handleSelectOccasion = (i, occasionCode) => {
        this.setState({
            occasionIndex: i,
            activePanel: 1,
            occasionCode,
        });
    };

    handleBackToOccasions = () => {
        this.setState({
            activePanel: 0,
        });
    };

    handleAddMessage = (message) => {
        const { callHandleChangeGiftMessage } = this.props;
        const { textField, showSuggestedMessages, occasionCode } = this.state;
        if (textField !== message) {
            this.setState({
                textField: message,
                characterCount: message.length,
                showSuggestedMessages: !showSuggestedMessages,
            });

            const pippedMessage = message.replace(/\n/g, '|');

            callHandleChangeGiftMessage(pippedMessage, occasionCode);
        }
    };

    render() {
        const {
            textField,
            characterCount,
            maxCharacters,
            showGiftMessage,
            showSuggestedMessages,
            occasionIndex,
            activePanel,
        } = this.state;
        const {
            classes,
            ssrDeviceType,
            featureFlags,
            presentationFamily,
            selectedSku,
            skuConfig,
            applePayStatus,
            totalItemInCart,
            passportSubscriptionStatus,
            isStandAloneMovieSku,
            movieSelected,
            hasWine,
        } = this.props;

        const allowOneClickPayment = selectedSku.ageVerifyFlag === 'false'
                                        && !hasWine
                                        && !passportSubscriptionStatus
                                        && !movieSelected
                                        && !isStandAloneMovieSku;

        const displayApplePay = typeof window !== 'undefined'
                                && window.ApplePaySession
                                && featureFlags['is-apple-pay-enabled-pdp'] === true
                                && allowOneClickPayment
                                && totalItemInCart === 0
                                && applePayStatus === 1
                                && skuConfig?.show_optional_gift_message;

        const displayGooglePay = featureFlags['is-pdp-google-pay-enabled']
                                && allowOneClickPayment
                                && (presentationFamily === 'flower'
                                    && googlePaySupportedBrand(selectedSku.brandId))
                                && skuConfig?.show_optional_gift_message;

        if (!displayApplePay && !displayGooglePay) {
            return null;
        }

        return (
            <Paper className={classes.optionalMessageMobile}>
                <div className={classes.root}>
                    {
                        (!showGiftMessage || ssrDeviceType !== 'mobile') && (
                            <FormControlLabel
                                label="Add optional gift message"
                                classes={{ label: classes.formCheckBoxLabel }}
                                control={(
                                    <Checkbox
                                        id="optional-messsage"
                                        data-test="pdp-optional-message"
                                        data-testid="pdp-optional-message"
                                        name="pdpMessage"
                                        disableRipple
                                        value="checkedB"
                                        color="primary"
                                        onChange={this.handleShowGiftMessage}
                                        classes={{
                                            root: classes.checkbox,
                                            checked: classes.checked,
                                        }}
                                    />
                                )}
                            />
                        )
                    }
                    <div
                        className={
                            showGiftMessage
                                ? classes.displayBlock
                                : classes.displayNone
                        }
                    >
                        <div className={classes.messageHeader}>
                            {ssrDeviceType === 'mobile' ? (
                                <div>
                                    {presentationFamily === 'flower' && (
                                        <Checkbox
                                            id="optional-messsage"
                                            name="pdpMessage"
                                            disableRipple
                                            value="checkedB"
                                            color="primary"
                                            onChange={this.handleShowGiftMessage}
                                            checked={showGiftMessage}
                                            classes={{
                                                root: classes.openCheckBox,
                                            }}
                                        />
                                    )}
                                    Optional Gift Message:
                                </div>
                            ) : (<div>GIFT MESSAGE: (OPTIONAL)</div>)}
                            <OccasionsDialog
                                showSuggestedMessages={showSuggestedMessages}
                                occasionIndex={occasionIndex}
                                activePanel={activePanel}
                                handleToggleSuggestedMessages={this.handleToggleSuggestedMessages}
                                handleSelectOccasion={this.handleSelectOccasion}
                                handleBackToOccasions={this.handleBackToOccasions}
                                handleAddMessage={this.handleAddMessage}
                            />
                        </div>
                        <div>
                            <Paper className={classes.paperBody} elevation={1}>
                                <TextField
                                    id="filled-multiline-static"
                                    data-test="pdp-filled-multiline-static"
                                    data-testid="pdp-filled-multiline-static"
                                    name="giftMessage"
                                    label={`Max Characters: ${maxCharacters
                                    - characterCount} characters left.`}
                                    multiline
                                    rows="4"
                                    value={textField}
                                    onChange={this.handleChange}
                                    className={classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Paper>
                        </div>
                    </div>
                </div>
            </Paper>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    callHandleChangeGiftMessage: bindActionCreators(loadAddToCartGiftMessage, dispatch),
});

const mapStateToProps = (state) => ({
    passportSubscriptionStatus: getPassportSubscriptionStatus(state),
    presentationFamily: getPresentationFamily(state),
    totalItemInCart: getTotalItemInCart(state),
    featureFlags: getFeatureFlags(state),
    applePayStatus: getApplePayStatus(state),
    ssrDeviceType: getSSRDeviceType(state),
});

GraphqlPDPGiftMessage.defaultProps = {
    hasWine: false,
    movieSelected: null,
};

GraphqlPDPGiftMessage.propTypes = {
    isStandAloneMovieSku: bool.isRequired,
    movieSelected: object,
    hasWine: bool,
    passportSubscriptionStatus: bool.isRequired,
    totalItemInCart: number.isRequired,
    skuConfig: object.isRequired,
    applePayStatus: number.isRequired,
    selectedSku: object.isRequired,
    presentationFamily: string.isRequired,
    featureFlags: object.isRequired,
    classes: object.isRequired,
    callHandleChangeGiftMessage: func.isRequired,
    ssrDeviceType: string.isRequired,
};

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
)(GraphqlPDPGiftMessage);
